import { COLORS } from "./constants";
import type { ChartLayout } from "./types";

export function drawLivePriceLine(
  ctx: CanvasRenderingContext2D,
  currentPrice: number,
  priceToY: (price: number) => number,
  layout: ChartLayout,
) {
  const { left, right, width: w } = layout;
  const y = priceToY(currentPrice);

  const label = currentPrice.toFixed(5);
  const paddingX = 6;

  ctx.font = "11px Arial";
  const textWidth = ctx.measureText(label).width;
  const boxWidth = textWidth + paddingX * 2;
  // align label with grid price labels (right-aligned at w - right - 4)
  const labelRightEdge = w - right - 4;
  const boxX = labelRightEdge - textWidth - paddingX;
  const boxY = y - 10.5;

  ctx.save();
  ctx.strokeStyle = COLORS.line;
  ctx.lineWidth = 0.8;
  ctx.setLineDash([]);
  ctx.beginPath();
  ctx.moveTo(left, y);
  ctx.lineTo(boxX, y);
  ctx.stroke();
  ctx.restore();

  ctx.fillStyle = COLORS.line;
  ctx.globalAlpha = 0.8;
  ctx.roundRect(boxX, boxY, boxWidth, 21, 4);
  ctx.fill();

  ctx.globalAlpha = 1;
  ctx.fillStyle = "#ffffff";
  ctx.textAlign = "right";
  ctx.textBaseline = "middle";
  ctx.fillText(label, labelRightEdge, y);
}
